
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-emerald-900 border-t border-emerald-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/1dec1d861b77ef7dee32dd8f5726e27a/ba451ff0391657a46ef5e851479ca2bc.jpeg" 
              alt="Carthaginian Treasure Logo" 
              className="h-36 md:h-48 w-auto mb-6"
            />
            <p className="text-emerald-100 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Bringing you the finest <strong>extra virgin olive oil</strong> from ancient Tunisian groves, crafted with <strong>6 generations</strong> of expertise.
            </p>
          </div>

          <div>
            <h5 className="text-lg font-bold text-white mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Quick Links
            </h5>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('heritage')}
                  className="text-emerald-200 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Our Heritage
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('process')}
                  className="text-emerald-200 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Our Process
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('benefits')}
                  className="text-emerald-200 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Health Benefits
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('story')}
                  className="text-emerald-200 hover:text-white transition-colors text-sm cursor-pointer"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Our Story
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold text-white mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Contact Us
            </h5>
            <ul className="space-y-3 text-sm text-emerald-200" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-emerald-300 mt-0.5"></i>
                <span>info@carthtreasure.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-emerald-300 mt-0.5"></i>
                <span>+1 (410) 253-1767</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-emerald-300 mt-0.5"></i>
                <span>Tunisia<br />& United States</span>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold text-white mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Follow Us
            </h5>
            <div className="flex gap-4 mb-6">
              <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-white text-lg"></i>
              </a>
            </div>
            <p className="text-emerald-200 text-sm leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Join our community and stay updated on new harvests and special offers.
            </p>
          </div>
        </div>

        <div className="border-t border-emerald-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-emerald-200">
            <p style={{ fontFamily: "'Montserrat', sans-serif" }}>
              © 2026 Carthaginian Treasure. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
